import * as $ from "jquery";

export class AjaxClient {
    public constructor(
        private readonly baseUrl: string,
        private readonly csrfToken: string,
    ) {}

    public call<TResponse = any>(path: string, data?: JQuery.PlainObject): Promise<TResponse> {
        if (data) {
            data._token = this.csrfToken; // eslint-disable-line no-underscore-dangle
        } else {
            data = { _token: this.csrfToken };
        }

        return this.wrapPromise(
            $.ajax({
                data,
                method: "POST",
                url: `${this.baseUrl}${path}`,
            }));
    }

    /**
     * Wraps a jQuery promise into a native promise.
     *
     * <p>This is needed since older versions of jQuery have a faulty Promise implementation.
     */
    private wrapPromise<TResponse = any>(jQueryPromise: JQuery.jqXHR): Promise<TResponse> {
        return new Promise((resolve, reject) => {
            void jQueryPromise.done(resolve).fail(reject);
        });
    }
}
